import { wrapTranslationsSchema } from '../../helpers/i18n/wrapTranslationsSchema';

export const BuyeasySupplierReviewsTranslations = wrapTranslationsSchema({
	name: 'BuyEasySupplierReviewsTranslations',
	title: 'Reviews Section Translations',
	sanityId: 'buyeasy-supplierReviews',
	fields: {
		reviews: 'Reviews',
		submittedOn: 'Submitted on',
		noReviews: 'No reviews have been submitted for this item.',
		thankYou: 'Thank you!',
		seeReviews: 'See reviews',
		yourFeedbackHasBeen:
			'Your feedback has been submitted. Thank you for sharing your feedback, your input helps us elevate supplier quality and deliver a better experience for you!',
		wereReallySorryButSomething:
			'We’re really sorry but something went wrong. Please try again later.',
		areYouSureYouWantToDelete: 'Are you sure you want to delete?',
		deletingYourReviewIsNotReversible:
			'Deleting your review is not reversible. Are you sure you want to delete it?',
		howWasYourSupplierExperience: 'How was your Supplier experience?',
		provideARating: 'Provide a rating',
		giveUsAReviewOfYourExperience: 'Give us a review of your experience',
		enterAnyAdditionalComments: 'Enter any additional comments...',
		characters: 'characters',
	},
});
